import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

export type UseJumpNavConfigProps<T = string> = {
  initialNavValue: T;
  sectionIds: T[];
};

export const elementOnScreenPercentage = (element: HTMLElement | null) => {
  if (!element) {
    return 0;
  }
  const headerOffset = 125;
  const screenHeight = window.innerHeight - 115;
  const rect = element.getBoundingClientRect();

  const visibleTop = Math.max(rect.top - headerOffset, 0);
  const visibleBottom = Math.min(rect.bottom - headerOffset, screenHeight);
  const visibleHeight = visibleBottom - visibleTop;
  const percentageOnScreen = Math.round(visibleHeight / (rect.height / 100));

  return Math.max(percentageOnScreen, 0);
};

export const useJumpNavConfig = <T extends string>({ initialNavValue, sectionIds }: UseJumpNavConfigProps<T>) => {
  const [ navValue, setNavValue ] = useState<T>(initialNavValue);

  useEffect(() => {
    const handleScroll = throttle(() => {
      const items = sectionIds.map(id => ({
        id,
        percentOnScreen: elementOnScreenPercentage(document.getElementById(id))
      })).sort((a, b) => b.percentOnScreen - a.percentOnScreen);

      if (items.length) {
        setNavValue(items[0].id);
      }
    }, 300);

    document.addEventListener('scroll', handleScroll, true);
    document.dispatchEvent(new Event('scroll'));

    return () => document.removeEventListener('scroll', handleScroll, true);
  }, [ sectionIds ]);

  return { navValue };
};
